import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isExternal?: boolean }>()(
  (theme, { isExternal }) => ({
    root: {
      height: '100%',
      backgroundColor: theme.palette.opaque.light,
      padding: theme.spacing(0, 4),
    },
    scroll: {
      height: 'calc(100vh - 100px)',
      overflowY: 'scroll',
    },
    revamp: {
      backgroundColor: theme.palette.text.white,
      padding: theme.spacing(isExternal ? 2 : 3.75, 2, 0, 5),
      borderRadius: theme.spacing(1),
      textAlign: 'left',
      '&::-webkit-scrollbar-track': {
        borderRadius: '18px',
        backgroundColor: theme.palette.bgPrimary.main,
      },
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
        backgroundColor: theme.palette.bgPrimary.main,
      },
      '&::-webkit-scrollbar-thumb': {
        width: '8px',
        borderRadius: '18px',
        backgroundColor: theme.palette.bgSecondary.main,
      },
    },
  })
)
